import React from 'react';
import { ICitizenLookup } from './interfaces';

export function formatCitizenValue(citizen?: ICitizenLookup) {
  return citizen ? `${citizen.fullName} ${formatCitizenCpr(citizen.cpr)}` : '';
}

function formatCitizenOption(citizen?: ICitizenLookup) {
  return citizen ? (
    <div>
      <div>{citizen.fullName}</div>
      <div>{formatCitizenCpr(citizen.cpr)}</div>
    </div>
  ) : (
    ''
  );
}

export function renderCitizen(props: object, citizen?: ICitizenLookup) {
  return (
    <li {...props} key={citizen?.citizenId}>
      {formatCitizenOption(citizen)}
    </li>
  );
}

export function formatCitizenCpr(cpr?: ICitizenLookup['cpr']) {
  return cpr ? `${cpr.substring(0, 6)}-${cpr.substring(6)}` : '';
}
